import { useState } from "react";
import MenuItem from "./MenuItem";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const Menu = ({ menuObj, isFirstHeading }) => {
	const isMobile = useMediaQuery("(max-width: 1024px)");
	// the menu is nested in an object where the key is the id —> {1: {...menu}}
	const menu = Object.values(menuObj)[0];
	const topLevelMenu = Object.values(menu.menu_items)[0];

	const [isOpen, setIsOpen] = useState(menu.slug === "whats-happening");

	const parseMenu = () => {
		if (!isOpen && isMobile) return null;

		if (!topLevelMenu || !topLevelMenu.children || !topLevelMenu.children.length) return null;

		return Object.values(topLevelMenu.children).map((child, index) => {
			const isFirstChild = index === 0;
			return <MenuItem key={child.id} isMobile={isMobile} item={child} isCurrentSeason={isFirstHeading && isFirstChild} />;
		});
	};

	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className={`menu ${isOpen ? "open" : "closed"}`}>
			<div className="menu__heading">
				<h4>
					<a className="menu__heading__link" href={topLevelMenu.url} dangerouslySetInnerHTML={{ __html: topLevelMenu.title }}></a>
				</h4>
				{isMobile && <button className={`menu__heading__button ${isOpen ? "open" : ""}`} aria-label={`expand navigation ${topLevelMenu.title} sub-menu`} onClick={handleClick}></button>}
			</div>
			<ul className="menu__list">{parseMenu()}</ul>
		</div>
	);
};

export default Menu;
